import React,{ Component } from 'react'
import moment from 'moment'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { enviaPedido, limpiaCarro, getMetodosEnvio,getCiudades,getProvincias } from '../actions'
class Direccion extends Component{
  
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      alert:"",
      respuesta:'',
      calle:"",
      altura:"",
      piso:"",
      tipo:"",
      pais:"Argentina",
      provincia:"Buenos Aires",
      ciudad:"Ciudad Autónoma de Buenos Aires",
      codpost:"",
      cont_apellido:"",
      cont_nombre:"",
      cont_condicion: "CONSUMIDORFINAL",
      cont_cuitcuil:"",
      cont_empresa:"",
      cont_telefono:"",
      cont_correo:"",
      metodos_envio:[],
      envio:""
    }
    this.enviaPedido = this.enviaPedido.bind(this)
    this.cambia = this.cambia.bind(this)
    this.validaForm = this.validaForm.bind(this)
    this.traeGeo = this.traeGeo.bind(this);
  }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
    var data = {}
    if (!this.props.usuario.perfil.hasOwnProperty("cargoPerfil")) {
      data.cont_apellido = this.props.usuario.perfil.apellido;
      data.cont_nombre = this.props.usuario.perfil.nombre;
      data.cont_correo = this.props.usuario.perfil.correo;
      this.setState(
        data,
        this.props.getProvincias()
      )
    } else {
      console.log("TIENE PERFIL")
      var datos = this.props.usuario.perfil
      datos.alert = ""
      this.setState(datos, this.traeGeo());
    }
  }

  componentDidUpdate(prevProps, prevState){  
    console.log(this.state)
    if(this.props.productos.end_point!="" && this.props.productos.end_point!=prevProps.productos.end_point){
      this.setState({loading:false,respuesta: "SE ENVIO CORRECTAMENTE"},() => {
        this.props.limpiaCarro()
        if(this.props.productos.end_point==="1"){
          this.props.history.push({
            pathname: '/aconfirmar',
            search: '?ref=' + this.props.productos.pedido_ref
          })
        }else{  
          window.open(this.props.productos.end_point, "_self")
        }
      })
    }else{
      if(this.props.metodos.length<1){
        this.props.getMetodosEnvio();
      }else{
        if(this.props.metodos != this.state.metodos_envio){
          this.setState({
            metodos_envio:this.props.metodos
          })
        }
      }
    }
  }

  enviaPedido = (e) => {
    e.preventDefault()
    this.setState({ loading: true }, () => {
      const valida = this.validaForm();
      if (valida.resp) {
        var total = 0;
        var unidades = 0;
        var cuerpo = "";

        const envio_tipo = this.state.metodos_envio.find(metodo => {
          return metodo.id === this.state.envio;
        });
        //console.log(envio_tipo);
        this.props.productos.carro.map((producto, i) => {
          total += parseFloat(producto.cantidad) * parseFloat(producto.precio);
          unidades += parseFloat(producto.cantidad);
          cuerpo += "<tr><td>" + producto.rubro_nombre + " " + producto.prod_nombre + " " + producto.nombre + "</td><td>" + producto.cantidad + "</td><td>$" + (parseFloat(producto.cantidad) * parseFloat(producto.precio)).toFixed(2) + ".-</td><tr>";
        });

        var totalAdic = (parseFloat(total) + ((parseFloat(total) * 21) / 100)).toFixed(2)
        //console.log(totalAdic);
        cuerpo += "<tr><td>IVA 21%</td><td> </td><td>$" + totalAdic + ".-</td><tr>";
        cuerpo += "<tr><td>" + envio_tipo.nombre + "</td><td> </td><td>$" + envio_tipo.costo + ".-</td><tr>";
        totalAdic = (parseFloat(totalAdic) + parseFloat(envio_tipo.costo)).toFixed(2)
        //console.log(totalAdic)
        cuerpo += "<tr><td>TOTAL</td><td> </td><td>$" + totalAdic + ".-</td><tr>";



        var data = { 
          usuario: { uid: this.props.usuario.user.uid, correo: this.props.usuario.user.email }, 
          destino: { calle: this.state.calle, altura: this.state.altura, piso: this.state.piso, tipo: this.state.tipo, pais: this.state.pais, provincia: this.state.provincia, ciudad: this.state.ciudad, codpost: this.state.codpost }, 
          contacto: { apellido: this.state.cont_apellido, nombre: this.state.cont_nombre, empresa: this.state.cont_empresa, cuitcuil: this.state.cont_cuitcuil, condicion: this.state.cont_condicion, telefono: this.state.cont_telefono, correo: this.state.cont_correo }, envio: envio_tipo, cuerpo: "<table>" + cuerpo + "</table>", monto: total.toFixed(2), iva: ((total * 21) / 100).toFixed(2), unidades: unidades, cantidad: this.props.productos.carro.length, stat: 0, pago: 0, aviso: false, fechaunix: moment().unix() };
          this.props.enviaPedido(this.props.usuario.user.uid, data, this.props.productos.carro);
      } else {
        this.setState({ alert: valida.msj, loading: false });
      }
    });
  }
  
  validaForm = () =>{
    if(this.state.calle==""){
      return {
        resp:false,
        msj:"DEBE COMPLETAR LA CALLE"
      }
    } else if (this.state.altura == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA ALTURA"
      }
    } else if (this.state.codpost == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL CODIGO POSTAL"
      }
    } else if (this.state.cont_nombre == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR SU NOMBRE"
      }
    } else if (this.state.cont_apellido == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR SU APELLIDO"
      }
    } else if (this.state.cont_cuitcuil == "" && this.state.cont_condicion!="CONSUMIDORFINAL") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR SU CUIT"
      }
    } else if (this.state.cont_correo == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA DIRECCION DE MAIL"
      }
    } else if (this.state.cont_telefono == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL TELEFONO"
      }
    } else if (this.state.cont_empresa == "" && this.state.cont_condicion != "CONSUMIDORFINAL") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA EMPRESA"
      }
    } else if (this.state.envio == "" ) {
      return {
        resp: false,
        msj: "DEBE SELECCIONAR UN METODO DE ENVIO"
      }
    }else{
      return {
        resp:true,
        msj:"PASO LA VALIDACION"
      }
    }
  }

  traeGeo() {
    this.props.getProvincias()
    if (this.state.provincia != "") {
      this.props.getCiudades(this.state.provincia)
    }
  }

  cambia = (key,value)=>{
    if (key === "provincia") {
      this.props.getCiudades(value)
    }
    this.setState({[key]:value})
  }



	render(){

    var provincias = []
    if (this.props.usuario.provincias) {
      var provs = this.props.usuario.provincias;
      provs.sort(function(a, b) {
        if (a.nombre > b.nombre) {
          return 1;
        }
        if (a.nombre < b.nombre) {
          return -1;
        }
        return 0;
      });
      provincias = provs.map((provincia, i) => {
        if (this.state.provincia != "" && this.state.provincia === provincia.nombre) {
          return <option key={i} value={provincia.nombre}>
              {provincia.nombre}
            </option>;
        } else {
          return <option key={i} value={provincia.nombre}>
              {provincia.nombre}
            </option>;
        }
      });
    }

    var ciudades = []
    if (this.props.usuario.ciudades) {
      var ciudadaesSort = this.props.usuario.ciudades;
      ciudadaesSort.sort(function(a, b) {
        if (a.nombre > b.nombre) {
          return 1;
        }
        if (a.nombre < b.nombre) {
          return -1;
        }
        return 0;
      });
      ciudades = ciudadaesSort.map((ciudad, i) => {
        return <option key={i} value={ciudad.nombre}>
            {ciudad.nombre}
          </option>;
      });
    }

    const metodosEnvios = this.props.metodos.map((metodo,i) => {
      return <option key={i} value={ metodo.id }>{metodo.nombre} [ $ {metodo.costo}.-]</option>
    })

		return <section className="container row mb-5 sombraHead mt-3 clearfix">
        <div className="col-md-4 mb-3" />

        {this.state.respuesta != "" ? <div className="col-md-6 mb-3">
            <h1 className="display-4">{this.state.respuesta}</h1>
          </div> : <div className="col-md-6 mb-3">
            {this.state.alert != "" && <div className="alert alert-danger" role="alert">
                {this.state.alert}
              </div>}
            <h1 className="display-4">Confirmar Dirección de Envío</h1>
            <form>
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label>Calle</label>
                  <input type="text" className="form-control" value={this.state.calle} id="calle" aria-describedby="emailHelp" placeholder="Ingrese el nombre de la calle" onChange={evt => this.cambia("calle", evt.target.value)} />
                </div>
                <div className="col-md-2 mb-3">
                  <label>Altura</label>
                  <input type="text" className="form-control" value={this.state.altura} id="Altura" placeholder="Altura" onChange={evt => this.cambia("altura", evt.target.value)} />
                </div>
                <div className="col-md-2 mb-3">
                  <label>Piso</label>
                  <input type="text" className="form-control" value={this.state.piso} id="Piso" placeholder="Piso" onChange={evt => this.cambia("piso", evt.target.value)} />
                </div>
                <div className="col-md-2 mb-3">
                  <label>Dpto</label>
                  <input type="text" className="form-control" value={this.state.tipo} id="Tipo" placeholder="Tipo" onChange={evt => this.cambia("tipo", evt.target.value)} />
                </div>
              </div>

              <div className="form-row">
                <div className="col-md-3 mb-3">
                  <label>Pais</label>
                  <select className="form-control form-control-sm" id="Pais" onChange={evt => this.cambia("pais", evt.target.value)}>
                    <option value="Argentina">Argentina</option>
                  </select>
                </div>

                <div className="col-md-3 mb-3">
                  <label>Provincia</label>
                  <select value={this.state.provincia} className="form-control form-control-sm" id="Provincia" onChange={evt => this.cambia("provincia", evt.target.value)}>
                    <option value="">SELECCIONAR</option>
                    {provincias}
                  </select>
                </div>

                <div className="col-md-3 mb-3">
                  <label>Ciudad</label>
                  <select value={this.state.ciudad} className="form-control form-control-sm" id="Ciudad" onChange={evt => this.cambia("ciudad", evt.target.value)}>
                    <option value="">SELECCIONAR</option>
                    {ciudades}
                  </select>
                </div>

                <div className="col-md-3 mb-3">
                  <label>Cod.Post</label>
                  <input type="text" className="form-control" value={this.state.codpost} id="codpost" placeholder="Codigo Postal" onChange={evt => this.cambia("codpost", evt.target.value)} />
                </div>
              </div>

              <p className="h5">Datos contacto</p>

              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label>Nombre</label>
                  <input type="text" className="form-control" value={this.state.cont_nombre} id="cont_nombre" placeholder="Ingrese el nombre del contacto" onChange={evt => this.cambia("cont_nombre", evt.target.value)} />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Apellido</label>
                  <input type="text" className="form-control" value={this.state.cont_apellido} id="cont_apellido" placeholder="Ingrese el apellido del contacto" onChange={evt => this.cambia("cont_apellido", evt.target.value)} />
                </div>
              </div>

              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label>Condición</label>
                  <select value={this.state.cont_condicion} className="form-control form-control-sm" id="cont_condicion" onChange={evt => this.cambia("cont_condicion", evt.target.value)}>
                    <option value="CONSUMIDORFINAL">
                      {" "}
                      CONSUMIDOR FINAL
                    </option>
                    <option value="RESPONSABLEINSCRIPTO">
                      {" "}
                      RESPONSABLE INSCRIPTO{" "}
                    </option>
                    <option value="EXENTO"> EXENTO </option>
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label>Cuil/Cuit</label>
                  <input type="text" className="form-control" value={this.state.cont_cuitcuil} id="cont_cuitcuil" placeholder="Ingrese su cuit/cuil" onChange={evt => this.cambia("cont_cuitcuil", evt.target.value)} />
                </div>
              </div>

              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label>Empresa</label>
                  <input type="text" className="form-control" value={this.state.cont_empresa} id="empresa" placeholder="Ingrese el nombre de la empresa" onChange={evt => this.cambia("cont_empresa", evt.target.value)} />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Telefono</label>
                  <input type="text" className="form-control" value={this.state.cont_telefono} id="cont_telefono" placeholder="Ingrese el telefono del contacto" onChange={evt => this.cambia("cont_telefono", evt.target.value)} />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label>Correo</label>
                  <input type="email" className="form-control" value={this.state.cont_correo} id="cont_correo" aria-describedby="emailHelp" placeholder="Enter email" onChange={evt => this.cambia("cont_correo", evt.target.value)} />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Envio</label>
                  <select className="form-control form-control-sm" id="envio" onChange={evt => this.cambia("envio", evt.target.value)}>
                    <option value=""> SELECCIONAR </option>
                    {metodosEnvios}
                  </select>
                </div>
              </div>
              {!this.state.loading ? <button type="submit" className="btn btn-primary" onClick={this.enviaPedido}>
                  Envia
                </button> : <h5>AGUARDE UN INSTANTE...</h5>}
            </form>
          </div>}
      </section>;
	}

};

const mapStateToProps = (state, ownProps) => {
  return {
      usuario: state.usuario,
      productos: state.productos,
      metodos:state.pedidos.metodos_envio
    }
}

const mapDispatchToProps = dispatch => {
  return {
    enviaPedido: (uid,dato,carro) => {
      dispatch(enviaPedido(uid,dato,carro))
    },
    limpiaCarro:() => {
      dispatch(limpiaCarro())
    },
    getMetodosEnvio:() => {
          dispatch(getMetodosEnvio())
    },
    getCiudades: (provincia) => {
      dispatch(getCiudades(provincia));
    },
    getProvincias: () => {
      dispatch(getProvincias());
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Direccion)



// WEBPACK FOOTER //
// ./src/containers/envia_pedido.js